export default __webpack_public_path__ + "static/media/team_syaiful.fc0b3fa5.jpg";